import Script from "next/script";
import React from "react";

interface OneTrustSnippetProps {
  id?: string;
  src?: string;
}

export const OneTrustSnippet: React.FC<OneTrustSnippetProps> = ({ id = "", src }) => {
  // Error on build if we do not have a oneTrustId for a given page.
  if (!id) {
    throw new Error(`OneTrustSnippet: Missing oneTrustId`);
  }

  return (
    <>
      <Script src={src || `https://cdn.cookielaw.org/consent/${id}/otSDKStub.js`} data-domain-script={id} />
      <Script id="optanon-wrapper">
        {`
          function OptanonWrapper() { }
        `}
      </Script>
    </>
  );
};
